export default "__VITE_ASSET__DahGllDU__"